import { theme } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { staticDashboardsPageContext } from "pages/[orgId]/dashboards/context";
import {
  mergeStateIntoDashboard,
  useDashboardRuntime,
} from "pages/[orgId]/dashboards/DashboardsDomain";
import { DashboardViewer } from "pages/[orgId]/dashboards/DashboardViewer";
import { DashboardV1State, DeepLinkType } from "pages/api/deep-links/types";
import { useDeepLinks } from "src/hooks/useDeepLinks";
import { SearchContext } from "../useSearchContext";
import { SubQueryPreviewProvider } from "./SubQueryPreview";

export function SubQueryDashboard({ context }: { context: SearchContext }) {
  const dashboards = useDeepLinks(DeepLinkType.BOARD);
  if (!dashboards.links.isFetched) return <LoadingOutlined />;
  const entityType = context.subquery.state?.select?.at(0) || "";
  const systemName = `subquery-${entityType}`;
  const named = dashboards.links.data?.find(
    (link) => (link.json as DashboardV1State).systemName === systemName
  );
  return named ? (
    <SubQueryDashboardViewer
      context={context}
      config={named.json as DashboardV1State}
    />
  ) : (
    <SubQueryPreviewProvider context={context} />
  );
}

function SubQueryDashboardViewer(props: {
  context: SearchContext;
  config: DashboardV1State;
}) {
  const { token } = theme.useToken();
  const [runtimeProps] = useDashboardRuntime({
    ...staticDashboardsPageContext,
    initialState: mergeStateIntoDashboard(
      props.config,
      props.context.subquery.state || {}
    ),
    dashboardId: "subquery",
    source: "embedded",
  });
  return (
    <div
      className="dashboards"
      style={{
        height: "calc(100% + 48px)",
        width: "calc(100% + 48px)",
        color: token.colorText,
        overflow: "auto",
        margin: -24,
        marginBottom: 0,
        backgroundColor: token.colorBgLayout,
      }}
    >
      <DashboardViewer key="viewer" {...runtimeProps} />
    </div>
  );
}
